import { render, staticRenderFns } from "./payorDetailList.vue?vue&type=template&id=4c837b96&scoped=true&"
import script from "./payorDetailList.vue?vue&type=script&lang=js&"
export * from "./payorDetailList.vue?vue&type=script&lang=js&"
import style0 from "./payorDetailList.vue?vue&type=style&index=0&id=4c837b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c837b96",
  null
  
)

export default component.exports